"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortByOrder = exports.SiteStatus = exports.SiteStaffRole = exports.ShipmentLabelStatus = exports.ScheduledItemType = exports.RegistrationStatus = exports.RecipeType = exports.PlatformType = exports.PhysicalActivityLevel = exports.NotificationTypeV2 = exports.NotificationType = exports.NotificationSource = exports.MenuType = exports.MealType = exports.MealProvisionOptionType = exports.MealOptionType = exports.MealOption = exports.MeUserTypeInput = exports.MainGoalType = exports.LogicCondition = exports.LogicAction = exports.IndicatorType = exports.GoogleOAuthRedirectPage = exports.FormBuilderQuestionType = exports.FoodProgramStatus = exports.FilterOp = exports.FeatureFlagType = exports.DocumentOwnerFilter = exports.DocumentOverwriteOption = exports.DishType = exports.DeviceNotificationChannel = exports.DeliveryStatus = exports.DeliverySettings = exports.DeliveryKey = exports.DateQuestionInitialState = exports.CustomFieldName = exports.CourseAssignmentTypes = exports.ContentExplanationType = exports.CoachPrefType = exports.AssignmentType = exports.AssignType = exports.AppointmentTypes = exports.AppointmentLocation = exports.AppointmentDuration = exports.AddressValidationStatus = exports.ActivityReminder = exports.ActivityKind = exports.ActivityFrequency = exports.ActivitiesPaginationMode = exports.AccessType = void 0;
exports.GetFoodProgramUserDocument = exports.ListDeliveriesV2Document = exports.ListDeliveriesDocument = exports.GetMenuOptionSelectionsDocument = exports.GetDishDocument = exports.DownloadDocumentDocument = exports.GetDocumentCountsDocument = exports.ListDocumentsDocument = exports.GetDocumentInfoDocument = exports.GetPreferencesDocument = exports.CountNewLearningAssignmentsDocument = exports.GetFeatureFlagsDocument = exports.GetFaQsDocument = exports.GetAvailableSurveysDocument = exports.GetArticlesDocument = exports.IsCtPresignupDocument = exports.GetProfileDocument = exports.GetLearningModulesDocument = exports.GetLearningModuleDocument = exports.GetEnvironmentNameDocument = exports.GetApiKeysDocument = exports.AnswerAnytimeSurveyForSubjectDocument = exports.AnswerDataSurveyBhbDocument = exports.UpdateUserSessionInfoDocument = exports.DeleteMeDocument = exports.DeleteDocumentDocument = exports.AddDocumentDocument = exports.UpdatePreferencesDocument = exports.ClearLearningBadgeDocument = exports.UpdatePatientMealSelectionV2Document = exports.UpdatePatientMealSelectionDocument = exports.CompleteLearningItemDocument = exports.ResetQuizDocument = exports.AnswerQuizDocument = exports.RegisterDeviceDocument = exports.AnswerSurveyDocument = exports.UpdateProfileDocument = exports.OptionFragmentDoc = exports.WeekDay = exports.VariationLevel = exports.ValidationType = exports.UserType = exports.UserGender = exports.TrialStatus = exports.TrackingStatus = exports.SurveyStatus = exports.SurveyQuestionType = exports.SurveyFrequency = exports.SubjectStatus = exports.StudyDietOptions = void 0;
exports.GetMealKitDocument = exports.ListAnytimeSurveyAssignmentsDocument = exports.GetUserIntercomHashKeyDocument = exports.GetRecipeDocument = exports.GetRecipesV2Document = exports.GetRecipesDocument = exports.ListBhbAssaysResultsDocument = exports.ListAminoAcidsAssaysResultsDocument = exports.GetLastAssayResultsDocument = exports.GetMyDietPlanDishesHistoryV2Document = exports.GetMyDietPlanDishesHistoryDocument = exports.GetInfoForAnalyticsDocument = exports.GetSurveyInstanceDocument = exports.GetDeliveryV2Document = exports.GetDeliveryDocument = exports.GetCryptoKeyDocument = exports.GetArticleTokenDocument = exports.GetSelectedMenuOptionsV2Document = exports.GetSelectedMenuOptionsDocument = exports.GetFoodProgramUserV2Document = void 0;
exports.useUpdateProfileMutation = useUpdateProfileMutation;
exports.useAnswerSurveyMutation = useAnswerSurveyMutation;
exports.useRegisterDeviceMutation = useRegisterDeviceMutation;
exports.useAnswerQuizMutation = useAnswerQuizMutation;
exports.useResetQuizMutation = useResetQuizMutation;
exports.useCompleteLearningItemMutation = useCompleteLearningItemMutation;
exports.useUpdatePatientMealSelectionMutation = useUpdatePatientMealSelectionMutation;
exports.useUpdatePatientMealSelectionV2Mutation = useUpdatePatientMealSelectionV2Mutation;
exports.useClearLearningBadgeMutation = useClearLearningBadgeMutation;
exports.useUpdatePreferencesMutation = useUpdatePreferencesMutation;
exports.useAddDocumentMutation = useAddDocumentMutation;
exports.useDeleteDocumentMutation = useDeleteDocumentMutation;
exports.useDeleteMeMutation = useDeleteMeMutation;
exports.useUpdateUserSessionInfoMutation = useUpdateUserSessionInfoMutation;
exports.useAnswerDataSurveyBhbMutation = useAnswerDataSurveyBhbMutation;
exports.useAnswerAnytimeSurveyForSubjectMutation = useAnswerAnytimeSurveyForSubjectMutation;
exports.useGetApiKeysQuery = useGetApiKeysQuery;
exports.useGetApiKeysLazyQuery = useGetApiKeysLazyQuery;
exports.useGetEnvironmentNameQuery = useGetEnvironmentNameQuery;
exports.useGetEnvironmentNameLazyQuery = useGetEnvironmentNameLazyQuery;
exports.useGetLearningModuleQuery = useGetLearningModuleQuery;
exports.useGetLearningModuleLazyQuery = useGetLearningModuleLazyQuery;
exports.useGetLearningModulesQuery = useGetLearningModulesQuery;
exports.useGetLearningModulesLazyQuery = useGetLearningModulesLazyQuery;
exports.useGetProfileQuery = useGetProfileQuery;
exports.useGetProfileLazyQuery = useGetProfileLazyQuery;
exports.useIsCtPresignupQuery = useIsCtPresignupQuery;
exports.useIsCtPresignupLazyQuery = useIsCtPresignupLazyQuery;
exports.useGetArticlesQuery = useGetArticlesQuery;
exports.useGetArticlesLazyQuery = useGetArticlesLazyQuery;
exports.useGetAvailableSurveysQuery = useGetAvailableSurveysQuery;
exports.useGetAvailableSurveysLazyQuery = useGetAvailableSurveysLazyQuery;
exports.useGetFaQsQuery = useGetFaQsQuery;
exports.useGetFaQsLazyQuery = useGetFaQsLazyQuery;
exports.useGetFeatureFlagsQuery = useGetFeatureFlagsQuery;
exports.useGetFeatureFlagsLazyQuery = useGetFeatureFlagsLazyQuery;
exports.useCountNewLearningAssignmentsQuery = useCountNewLearningAssignmentsQuery;
exports.useCountNewLearningAssignmentsLazyQuery = useCountNewLearningAssignmentsLazyQuery;
exports.useGetPreferencesQuery = useGetPreferencesQuery;
exports.useGetPreferencesLazyQuery = useGetPreferencesLazyQuery;
exports.useGetDocumentInfoQuery = useGetDocumentInfoQuery;
exports.useGetDocumentInfoLazyQuery = useGetDocumentInfoLazyQuery;
exports.useListDocumentsQuery = useListDocumentsQuery;
exports.useListDocumentsLazyQuery = useListDocumentsLazyQuery;
exports.useGetDocumentCountsQuery = useGetDocumentCountsQuery;
exports.useGetDocumentCountsLazyQuery = useGetDocumentCountsLazyQuery;
exports.useDownloadDocumentQuery = useDownloadDocumentQuery;
exports.useDownloadDocumentLazyQuery = useDownloadDocumentLazyQuery;
exports.useGetDishQuery = useGetDishQuery;
exports.useGetDishLazyQuery = useGetDishLazyQuery;
exports.useGetMenuOptionSelectionsQuery = useGetMenuOptionSelectionsQuery;
exports.useGetMenuOptionSelectionsLazyQuery = useGetMenuOptionSelectionsLazyQuery;
exports.useListDeliveriesQuery = useListDeliveriesQuery;
exports.useListDeliveriesLazyQuery = useListDeliveriesLazyQuery;
exports.useListDeliveriesV2Query = useListDeliveriesV2Query;
exports.useListDeliveriesV2LazyQuery = useListDeliveriesV2LazyQuery;
exports.useGetFoodProgramUserQuery = useGetFoodProgramUserQuery;
exports.useGetFoodProgramUserLazyQuery = useGetFoodProgramUserLazyQuery;
exports.useGetFoodProgramUserV2Query = useGetFoodProgramUserV2Query;
exports.useGetFoodProgramUserV2LazyQuery = useGetFoodProgramUserV2LazyQuery;
exports.useGetSelectedMenuOptionsQuery = useGetSelectedMenuOptionsQuery;
exports.useGetSelectedMenuOptionsLazyQuery = useGetSelectedMenuOptionsLazyQuery;
exports.useGetSelectedMenuOptionsV2Query = useGetSelectedMenuOptionsV2Query;
exports.useGetSelectedMenuOptionsV2LazyQuery = useGetSelectedMenuOptionsV2LazyQuery;
exports.useGetArticleTokenQuery = useGetArticleTokenQuery;
exports.useGetArticleTokenLazyQuery = useGetArticleTokenLazyQuery;
exports.useGetCryptoKeyQuery = useGetCryptoKeyQuery;
exports.useGetCryptoKeyLazyQuery = useGetCryptoKeyLazyQuery;
exports.useGetDeliveryQuery = useGetDeliveryQuery;
exports.useGetDeliveryLazyQuery = useGetDeliveryLazyQuery;
exports.useGetDeliveryV2Query = useGetDeliveryV2Query;
exports.useGetDeliveryV2LazyQuery = useGetDeliveryV2LazyQuery;
exports.useGetSurveyInstanceQuery = useGetSurveyInstanceQuery;
exports.useGetSurveyInstanceLazyQuery = useGetSurveyInstanceLazyQuery;
exports.useGetInfoForAnalyticsQuery = useGetInfoForAnalyticsQuery;
exports.useGetInfoForAnalyticsLazyQuery = useGetInfoForAnalyticsLazyQuery;
exports.useGetMyDietPlanDishesHistoryQuery = useGetMyDietPlanDishesHistoryQuery;
exports.useGetMyDietPlanDishesHistoryLazyQuery = useGetMyDietPlanDishesHistoryLazyQuery;
exports.useGetMyDietPlanDishesHistoryV2Query = useGetMyDietPlanDishesHistoryV2Query;
exports.useGetMyDietPlanDishesHistoryV2LazyQuery = useGetMyDietPlanDishesHistoryV2LazyQuery;
exports.useGetLastAssayResultsQuery = useGetLastAssayResultsQuery;
exports.useGetLastAssayResultsLazyQuery = useGetLastAssayResultsLazyQuery;
exports.useListAminoAcidsAssaysResultsQuery = useListAminoAcidsAssaysResultsQuery;
exports.useListAminoAcidsAssaysResultsLazyQuery = useListAminoAcidsAssaysResultsLazyQuery;
exports.useListBhbAssaysResultsQuery = useListBhbAssaysResultsQuery;
exports.useListBhbAssaysResultsLazyQuery = useListBhbAssaysResultsLazyQuery;
exports.useGetRecipesQuery = useGetRecipesQuery;
exports.useGetRecipesLazyQuery = useGetRecipesLazyQuery;
exports.useGetRecipesV2Query = useGetRecipesV2Query;
exports.useGetRecipesV2LazyQuery = useGetRecipesV2LazyQuery;
exports.useGetRecipeQuery = useGetRecipeQuery;
exports.useGetRecipeLazyQuery = useGetRecipeLazyQuery;
exports.useGetUserIntercomHashKeyQuery = useGetUserIntercomHashKeyQuery;
exports.useGetUserIntercomHashKeyLazyQuery = useGetUserIntercomHashKeyLazyQuery;
exports.useListAnytimeSurveyAssignmentsQuery = useListAnytimeSurveyAssignmentsQuery;
exports.useListAnytimeSurveyAssignmentsLazyQuery = useListAnytimeSurveyAssignmentsLazyQuery;
exports.useGetMealKitQuery = useGetMealKitQuery;
exports.useGetMealKitLazyQuery = useGetMealKitLazyQuery;
var client_1 = require("@apollo/client");
var Apollo = __importStar(require("@apollo/client"));
var defaultOptions = {};
var AccessType;
(function (AccessType) {
    AccessType["Download"] = "download";
    AccessType["Upload"] = "upload";
})(AccessType || (exports.AccessType = AccessType = {}));
var ActivitiesPaginationMode;
(function (ActivitiesPaginationMode) {
    ActivitiesPaginationMode["Backward"] = "Backward";
    ActivitiesPaginationMode["Bidirectional"] = "Bidirectional";
    ActivitiesPaginationMode["Forward"] = "Forward";
})(ActivitiesPaginationMode || (exports.ActivitiesPaginationMode = ActivitiesPaginationMode = {}));
var ActivityFrequency;
(function (ActivityFrequency) {
    ActivityFrequency["Biweekly"] = "Biweekly";
    ActivityFrequency["Daily"] = "Daily";
    ActivityFrequency["Monthly"] = "Monthly";
    ActivityFrequency["Once"] = "Once";
    ActivityFrequency["Triweekly"] = "Triweekly";
    ActivityFrequency["Weekly"] = "Weekly";
})(ActivityFrequency || (exports.ActivityFrequency = ActivityFrequency = {}));
var ActivityKind;
(function (ActivityKind) {
    ActivityKind["Appointment"] = "Appointment";
    ActivityKind["Goal"] = "Goal";
    ActivityKind["Task"] = "Task";
})(ActivityKind || (exports.ActivityKind = ActivityKind = {}));
var ActivityReminder;
(function (ActivityReminder) {
    ActivityReminder["FifteenMinutes"] = "FifteenMinutes";
    ActivityReminder["Never"] = "Never";
    ActivityReminder["OneDay"] = "OneDay";
    ActivityReminder["TenMinutes"] = "TenMinutes";
    ActivityReminder["ThirtyMinutes"] = "ThirtyMinutes";
})(ActivityReminder || (exports.ActivityReminder = ActivityReminder = {}));
var AddressValidationStatus;
(function (AddressValidationStatus) {
    AddressValidationStatus["Invalid"] = "Invalid";
    AddressValidationStatus["MissingComplement"] = "MissingComplement";
    AddressValidationStatus["Ok"] = "Ok";
})(AddressValidationStatus || (exports.AddressValidationStatus = AddressValidationStatus = {}));
var AppointmentDuration;
(function (AppointmentDuration) {
    AppointmentDuration["FifteenMinutes"] = "FifteenMinutes";
    AppointmentDuration["OneHour"] = "OneHour";
    AppointmentDuration["ThirtyMinutes"] = "ThirtyMinutes";
})(AppointmentDuration || (exports.AppointmentDuration = AppointmentDuration = {}));
var AppointmentLocation;
(function (AppointmentLocation) {
    AppointmentLocation["InPerson"] = "InPerson";
    AppointmentLocation["Virtual"] = "Virtual";
})(AppointmentLocation || (exports.AppointmentLocation = AppointmentLocation = {}));
var AppointmentTypes;
(function (AppointmentTypes) {
    AppointmentTypes["Obp1"] = "OBP1";
})(AppointmentTypes || (exports.AppointmentTypes = AppointmentTypes = {}));
var AssignType;
(function (AssignType) {
    AssignType["DhAndCaretaker"] = "dh_and_caretaker";
    AssignType["Manual"] = "manual";
})(AssignType || (exports.AssignType = AssignType = {}));
var AssignmentType;
(function (AssignmentType) {
    AssignmentType["Available"] = "available";
    AssignmentType["Required"] = "required";
})(AssignmentType || (exports.AssignmentType = AssignmentType = {}));
var CoachPrefType;
(function (CoachPrefType) {
    CoachPrefType["Female"] = "female";
    CoachPrefType["Male"] = "male";
    CoachPrefType["NoPref"] = "no_pref";
})(CoachPrefType || (exports.CoachPrefType = CoachPrefType = {}));
var ContentExplanationType;
(function (ContentExplanationType) {
    ContentExplanationType["Image"] = "image";
    ContentExplanationType["Text"] = "text";
})(ContentExplanationType || (exports.ContentExplanationType = ContentExplanationType = {}));
var CourseAssignmentTypes;
(function (CourseAssignmentTypes) {
    CourseAssignmentTypes["None"] = "none";
    CourseAssignmentTypes["Site"] = "site";
    CourseAssignmentTypes["Trial"] = "trial";
})(CourseAssignmentTypes || (exports.CourseAssignmentTypes = CourseAssignmentTypes = {}));
var CustomFieldName;
(function (CustomFieldName) {
    CustomFieldName["Sachets"] = "sachets";
    CustomFieldName["TreatmentStartDate"] = "treatmentStartDate";
})(CustomFieldName || (exports.CustomFieldName = CustomFieldName = {}));
var DateQuestionInitialState;
(function (DateQuestionInitialState) {
    DateQuestionInitialState["NoPreloadedDate"] = "noPreloadedDate";
    DateQuestionInitialState["PreloadedWithCurrentDate"] = "preloadedWithCurrentDate";
})(DateQuestionInitialState || (exports.DateQuestionInitialState = DateQuestionInitialState = {}));
var DeliveryKey;
(function (DeliveryKey) {
    DeliveryKey["WeekAFirst"] = "weekAFirst";
    DeliveryKey["WeekASecond"] = "weekASecond";
    DeliveryKey["WeekBFirst"] = "weekBFirst";
    DeliveryKey["WeekBSecond"] = "weekBSecond";
    DeliveryKey["WeekCFirst"] = "weekCFirst";
    DeliveryKey["WeekCSecond"] = "weekCSecond";
})(DeliveryKey || (exports.DeliveryKey = DeliveryKey = {}));
var DeliverySettings;
(function (DeliverySettings) {
    DeliverySettings["Fewest"] = "fewest";
    DeliverySettings["Freshest"] = "freshest";
})(DeliverySettings || (exports.DeliverySettings = DeliverySettings = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["Closed"] = "closed";
    DeliveryStatus["Open"] = "open";
})(DeliveryStatus || (exports.DeliveryStatus = DeliveryStatus = {}));
var DeviceNotificationChannel;
(function (DeviceNotificationChannel) {
    DeviceNotificationChannel["Apns"] = "APNS";
    DeviceNotificationChannel["Gcm"] = "GCM";
})(DeviceNotificationChannel || (exports.DeviceNotificationChannel = DeviceNotificationChannel = {}));
var DishType;
(function (DishType) {
    DishType["Meal"] = "meal";
    DishType["Snack"] = "snack";
})(DishType || (exports.DishType = DishType = {}));
var DocumentOverwriteOption;
(function (DocumentOverwriteOption) {
    DocumentOverwriteOption["Overwrite"] = "overwrite";
    DocumentOverwriteOption["Preserve"] = "preserve";
})(DocumentOverwriteOption || (exports.DocumentOverwriteOption = DocumentOverwriteOption = {}));
var DocumentOwnerFilter;
(function (DocumentOwnerFilter) {
    DocumentOwnerFilter["Both"] = "both";
    DocumentOwnerFilter["Coach"] = "coach";
    DocumentOwnerFilter["Patient"] = "patient";
})(DocumentOwnerFilter || (exports.DocumentOwnerFilter = DocumentOwnerFilter = {}));
var FeatureFlagType;
(function (FeatureFlagType) {
    FeatureFlagType["Mobile"] = "Mobile";
    FeatureFlagType["Web"] = "Web";
})(FeatureFlagType || (exports.FeatureFlagType = FeatureFlagType = {}));
var FilterOp;
(function (FilterOp) {
    FilterOp["Equal"] = "equal";
    FilterOp["Includes"] = "includes";
})(FilterOp || (exports.FilterOp = FilterOp = {}));
var FoodProgramStatus;
(function (FoodProgramStatus) {
    FoodProgramStatus["Active"] = "active";
    FoodProgramStatus["Archived"] = "archived";
})(FoodProgramStatus || (exports.FoodProgramStatus = FoodProgramStatus = {}));
var FormBuilderQuestionType;
(function (FormBuilderQuestionType) {
    FormBuilderQuestionType["Binary"] = "Binary";
    FormBuilderQuestionType["Date"] = "Date";
    FormBuilderQuestionType["MultipleChoice"] = "MultipleChoice";
    FormBuilderQuestionType["Number"] = "Number";
    FormBuilderQuestionType["OpenText"] = "OpenText";
    FormBuilderQuestionType["Scale"] = "Scale";
    FormBuilderQuestionType["SingleChoice"] = "SingleChoice";
})(FormBuilderQuestionType || (exports.FormBuilderQuestionType = FormBuilderQuestionType = {}));
var GoogleOAuthRedirectPage;
(function (GoogleOAuthRedirectPage) {
    GoogleOAuthRedirectPage["AddActivity"] = "AddActivity";
    GoogleOAuthRedirectPage["EditActivity"] = "EditActivity";
})(GoogleOAuthRedirectPage || (exports.GoogleOAuthRedirectPage = GoogleOAuthRedirectPage = {}));
var IndicatorType;
(function (IndicatorType) {
    IndicatorType["Aminoacids"] = "Aminoacids";
    IndicatorType["Bhb"] = "Bhb";
})(IndicatorType || (exports.IndicatorType = IndicatorType = {}));
var LogicAction;
(function (LogicAction) {
    LogicAction["Hide"] = "Hide";
    LogicAction["Show"] = "Show";
})(LogicAction || (exports.LogicAction = LogicAction = {}));
var LogicCondition;
(function (LogicCondition) {
    LogicCondition["Contains"] = "Contains";
    LogicCondition["EqualTo"] = "EqualTo";
    LogicCondition["NotContains"] = "NotContains";
    LogicCondition["NotEqualTo"] = "NotEqualTo";
})(LogicCondition || (exports.LogicCondition = LogicCondition = {}));
var MainGoalType;
(function (MainGoalType) {
    MainGoalType["Connect"] = "connect";
    MainGoalType["Learn"] = "learn";
    MainGoalType["Support"] = "support";
    MainGoalType["Track"] = "track";
})(MainGoalType || (exports.MainGoalType = MainGoalType = {}));
var MeUserTypeInput;
(function (MeUserTypeInput) {
    MeUserTypeInput["Caretaker"] = "caretaker";
    MeUserTypeInput["Patient"] = "patient";
})(MeUserTypeInput || (exports.MeUserTypeInput = MeUserTypeInput = {}));
var MealOption;
(function (MealOption) {
    MealOption["Dish"] = "dish";
    MealOption["MealKit"] = "meal_kit";
})(MealOption || (exports.MealOption = MealOption = {}));
var MealOptionType;
(function (MealOptionType) {
    MealOptionType["Dish"] = "dish";
    MealOptionType["MealKit"] = "meal_kit";
})(MealOptionType || (exports.MealOptionType = MealOptionType = {}));
var MealProvisionOptionType;
(function (MealProvisionOptionType) {
    MealProvisionOptionType["FaethProvided"] = "faeth_provided";
    MealProvisionOptionType["MealKit"] = "meal_kit";
    MealProvisionOptionType["SelfPrepared"] = "self_prepared";
})(MealProvisionOptionType || (exports.MealProvisionOptionType = MealProvisionOptionType = {}));
var MealType;
(function (MealType) {
    MealType["Breakfast"] = "breakfast";
    MealType["Dinner"] = "dinner";
    MealType["Lunch"] = "lunch";
    MealType["Sides"] = "sides";
    MealType["Snacks"] = "snacks";
})(MealType || (exports.MealType = MealType = {}));
var MenuType;
(function (MenuType) {
    MenuType["QuickShip"] = "quick_ship";
    MenuType["Regular"] = "regular";
})(MenuType || (exports.MenuType = MenuType = {}));
var NotificationSource;
(function (NotificationSource) {
    NotificationSource["Activity"] = "activity";
    NotificationSource["Chat"] = "chat";
    NotificationSource["Documents"] = "documents";
    NotificationSource["Learning"] = "learning";
    NotificationSource["Meals"] = "meals";
    NotificationSource["Survey"] = "survey";
})(NotificationSource || (exports.NotificationSource = NotificationSource = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["None"] = "none";
    NotificationType["Push"] = "push";
    NotificationType["Sms"] = "sms";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var NotificationTypeV2;
(function (NotificationTypeV2) {
    NotificationTypeV2["Push"] = "push";
    NotificationTypeV2["Sms"] = "sms";
})(NotificationTypeV2 || (exports.NotificationTypeV2 = NotificationTypeV2 = {}));
var PhysicalActivityLevel;
(function (PhysicalActivityLevel) {
    PhysicalActivityLevel["Moderately"] = "moderately";
    PhysicalActivityLevel["Sedentary"] = "sedentary";
    PhysicalActivityLevel["SlightlyActive"] = "slightly_active";
    PhysicalActivityLevel["VeryActive"] = "very_active";
})(PhysicalActivityLevel || (exports.PhysicalActivityLevel = PhysicalActivityLevel = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["Android"] = "Android";
    PlatformType["Ios"] = "Ios";
    PlatformType["Web"] = "Web";
})(PlatformType || (exports.PlatformType = PlatformType = {}));
var RecipeType;
(function (RecipeType) {
    RecipeType["Breakfast"] = "Breakfast";
    RecipeType["Dinner"] = "Dinner";
    RecipeType["Lunch"] = "Lunch";
    RecipeType["Snack"] = "Snack";
})(RecipeType || (exports.RecipeType = RecipeType = {}));
var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["Confirmed"] = "CONFIRMED";
    RegistrationStatus["ForceChangePassword"] = "FORCE_CHANGE_PASSWORD";
})(RegistrationStatus || (exports.RegistrationStatus = RegistrationStatus = {}));
var ScheduledItemType;
(function (ScheduledItemType) {
    ScheduledItemType["Appointment"] = "appointment";
    ScheduledItemType["Article"] = "article";
    ScheduledItemType["Bhb"] = "bhb";
    ScheduledItemType["Goal"] = "goal";
    ScheduledItemType["Learning"] = "learning";
    ScheduledItemType["Medication"] = "medication";
    ScheduledItemType["Survey"] = "survey";
    ScheduledItemType["Task"] = "task";
})(ScheduledItemType || (exports.ScheduledItemType = ScheduledItemType = {}));
var ShipmentLabelStatus;
(function (ShipmentLabelStatus) {
    ShipmentLabelStatus["Error"] = "ERROR";
    ShipmentLabelStatus["Queued"] = "QUEUED";
    ShipmentLabelStatus["Refunded"] = "REFUNDED";
    ShipmentLabelStatus["Refundpending"] = "REFUNDPENDING";
    ShipmentLabelStatus["Refundrejected"] = "REFUNDREJECTED";
    ShipmentLabelStatus["Success"] = "SUCCESS";
    ShipmentLabelStatus["Waiting"] = "WAITING";
})(ShipmentLabelStatus || (exports.ShipmentLabelStatus = ShipmentLabelStatus = {}));
var SiteStaffRole;
(function (SiteStaffRole) {
    SiteStaffRole["Crc"] = "crc";
    SiteStaffRole["Nurse"] = "nurse";
    SiteStaffRole["Pi"] = "pi";
    SiteStaffRole["SubI"] = "sub_i";
})(SiteStaffRole || (exports.SiteStaffRole = SiteStaffRole = {}));
var SiteStatus;
(function (SiteStatus) {
    SiteStatus["Active"] = "active";
    SiteStatus["Inactive"] = "inactive";
})(SiteStatus || (exports.SiteStatus = SiteStatus = {}));
var SortByOrder;
(function (SortByOrder) {
    SortByOrder["Asc"] = "asc";
    SortByOrder["Desc"] = "desc";
})(SortByOrder || (exports.SortByOrder = SortByOrder = {}));
var StudyDietOptions;
(function (StudyDietOptions) {
    StudyDietOptions["All"] = "All";
    StudyDietOptions["Most"] = "Most";
    StudyDietOptions["None"] = "None";
    StudyDietOptions["Some"] = "Some";
})(StudyDietOptions || (exports.StudyDietOptions = StudyDietOptions = {}));
var SubjectStatus;
(function (SubjectStatus) {
    SubjectStatus["CoachApproved"] = "coach_approved";
    SubjectStatus["Discontinued"] = "discontinued";
    SubjectStatus["Draft"] = "draft";
    SubjectStatus["Ongoing"] = "ongoing";
    SubjectStatus["ScreenFailed"] = "screen_failed";
    SubjectStatus["Screening"] = "screening";
    SubjectStatus["StudyCompleted"] = "study_completed";
})(SubjectStatus || (exports.SubjectStatus = SubjectStatus = {}));
var SurveyFrequency;
(function (SurveyFrequency) {
    SurveyFrequency["Biweekly"] = "Biweekly";
    SurveyFrequency["Daily"] = "Daily";
    SurveyFrequency["DaysOnDiet"] = "DaysOnDiet";
    SurveyFrequency["Monthly"] = "Monthly";
    SurveyFrequency["Once"] = "Once";
    SurveyFrequency["Triweekly"] = "Triweekly";
    SurveyFrequency["Weekly"] = "Weekly";
})(SurveyFrequency || (exports.SurveyFrequency = SurveyFrequency = {}));
var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType["Binary"] = "Binary";
    SurveyQuestionType["Date"] = "Date";
    SurveyQuestionType["Decimal"] = "Decimal";
    SurveyQuestionType["Explanation"] = "Explanation";
    SurveyQuestionType["Meal"] = "Meal";
    SurveyQuestionType["MultipleChoice"] = "MultipleChoice";
    SurveyQuestionType["Number"] = "Number";
    SurveyQuestionType["OpenText"] = "OpenText";
    SurveyQuestionType["Scale"] = "Scale";
    SurveyQuestionType["SingleChoice"] = "SingleChoice";
    SurveyQuestionType["Snack"] = "Snack";
    SurveyQuestionType["Time"] = "Time";
})(SurveyQuestionType || (exports.SurveyQuestionType = SurveyQuestionType = {}));
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["Done"] = "Done";
    SurveyStatus["Late"] = "Late";
    SurveyStatus["Missing"] = "Missing";
    SurveyStatus["Open"] = "Open";
})(SurveyStatus || (exports.SurveyStatus = SurveyStatus = {}));
var TrackingStatus;
(function (TrackingStatus) {
    TrackingStatus["BeingPrepared"] = "BEING_PREPARED";
    TrackingStatus["Delivered"] = "DELIVERED";
    TrackingStatus["Failure"] = "FAILURE";
    TrackingStatus["Returned"] = "RETURNED";
    TrackingStatus["Transit"] = "TRANSIT";
    TrackingStatus["Unknown"] = "UNKNOWN";
})(TrackingStatus || (exports.TrackingStatus = TrackingStatus = {}));
var TrialStatus;
(function (TrialStatus) {
    TrialStatus["ActiveNotRecruiting"] = "active_not_recruiting";
    TrialStatus["Completed"] = "completed";
    TrialStatus["NotYetRecruiting"] = "not_yet_recruiting";
    TrialStatus["Recruiting"] = "recruiting";
    TrialStatus["Terminated"] = "terminated";
})(TrialStatus || (exports.TrialStatus = TrialStatus = {}));
var UserGender;
(function (UserGender) {
    UserGender["Female"] = "female";
    UserGender["Male"] = "male";
})(UserGender || (exports.UserGender = UserGender = {}));
var UserType;
(function (UserType) {
    UserType["Caretaker"] = "caretaker";
    UserType["ClinicalTrialPatient"] = "clinical_trial_patient";
    UserType["Coach"] = "coach";
    UserType["CustomerService"] = "customer_service";
    UserType["Foodops"] = "foodops";
    UserType["Patient"] = "patient";
    UserType["SiteStaff"] = "site_staff";
})(UserType || (exports.UserType = UserType = {}));
var ValidationType;
(function (ValidationType) {
    ValidationType["Date"] = "date";
    ValidationType["NotAllowed"] = "notAllowed";
})(ValidationType || (exports.ValidationType = ValidationType = {}));
var VariationLevel;
(function (VariationLevel) {
    VariationLevel["Average"] = "Average";
    VariationLevel["High"] = "High";
    VariationLevel["Low"] = "Low";
    VariationLevel["VeryLow"] = "VeryLow";
})(VariationLevel || (exports.VariationLevel = VariationLevel = {}));
var WeekDay;
(function (WeekDay) {
    WeekDay["Fri"] = "Fri";
    WeekDay["Mon"] = "Mon";
    WeekDay["Sat"] = "Sat";
    WeekDay["Sun"] = "Sun";
    WeekDay["Thu"] = "Thu";
    WeekDay["Tue"] = "Tue";
    WeekDay["Wed"] = "Wed";
})(WeekDay || (exports.WeekDay = WeekDay = {}));
exports.OptionFragmentDoc = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Option on MenuOptionSelection {\n  menuOptionId\n  dishId\n  referenceId\n  name\n  photoUrl\n  quantity\n  type\n  mealOptionType\n  mealkitVariantIngredientName\n  mealkitVariantId\n  tagsByCategory {\n    categoryId\n    categoryName\n    tags {\n      id\n      name\n    }\n  }\n}\n    "], ["\n    fragment Option on MenuOptionSelection {\n  menuOptionId\n  dishId\n  referenceId\n  name\n  photoUrl\n  quantity\n  type\n  mealOptionType\n  mealkitVariantIngredientName\n  mealkitVariantId\n  tagsByCategory {\n    categoryId\n    categoryName\n    tags {\n      id\n      name\n    }\n  }\n}\n    "])));
exports.UpdateProfileDocument = (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation updateProfile($props: MeInput!) {\n  me(myProps: $props) {\n    id\n    email\n    phone_number\n    name\n    birthdate\n    picture\n    is_learn_active\n    address {\n      formatted\n      street_address\n      locality\n      region\n      postal_code\n      country\n      complement\n    }\n    last_in_app_review\n    main_goal\n  }\n}\n    "], ["\n    mutation updateProfile($props: MeInput!) {\n  me(myProps: $props) {\n    id\n    email\n    phone_number\n    name\n    birthdate\n    picture\n    is_learn_active\n    address {\n      formatted\n      street_address\n      locality\n      region\n      postal_code\n      country\n      complement\n    }\n    last_in_app_review\n    main_goal\n  }\n}\n    "])));
/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      props: // value for 'props'
 *   },
 * });
 */
function useUpdateProfileMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateProfileDocument, options);
}
exports.AnswerSurveyDocument = (0, client_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    mutation answerSurvey($instanceId: String!, $answers: [SurveyQuestionAnswer!]!) {\n  answerSurvey(instanceId: $instanceId, answers: $answers)\n}\n    "], ["\n    mutation answerSurvey($instanceId: String!, $answers: [SurveyQuestionAnswer!]!) {\n  answerSurvey(instanceId: $instanceId, answers: $answers)\n}\n    "])));
/**
 * __useAnswerSurveyMutation__
 *
 * To run a mutation, you first call `useAnswerSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSurveyMutation, { data, loading, error }] = useAnswerSurveyMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
function useAnswerSurveyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AnswerSurveyDocument, options);
}
exports.RegisterDeviceDocument = (0, client_1.gql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    mutation registerDevice($device: DeviceInput!) {\n  registerDevice(device: $device) {\n    id\n    token\n    channel\n  }\n}\n    "], ["\n    mutation registerDevice($device: DeviceInput!) {\n  registerDevice(device: $device) {\n    id\n    token\n    channel\n  }\n}\n    "])));
/**
 * __useRegisterDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceMutation, { data, loading, error }] = useRegisterDeviceMutation({
 *   variables: {
 *      device: // value for 'device'
 *   },
 * });
 */
function useRegisterDeviceMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.RegisterDeviceDocument, options);
}
exports.AnswerQuizDocument = (0, client_1.gql)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    mutation answerQuiz($quizId: String!, $learningModuleId: String!, $answers: [QuizQuestionAnswerInput!]!) {\n  answerQuiz(\n    quizId: $quizId\n    learningModuleId: $learningModuleId\n    answers: $answers\n  )\n}\n    "], ["\n    mutation answerQuiz($quizId: String!, $learningModuleId: String!, $answers: [QuizQuestionAnswerInput!]!) {\n  answerQuiz(\n    quizId: $quizId\n    learningModuleId: $learningModuleId\n    answers: $answers\n  )\n}\n    "])));
/**
 * __useAnswerQuizMutation__
 *
 * To run a mutation, you first call `useAnswerQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuizMutation, { data, loading, error }] = useAnswerQuizMutation({
 *   variables: {
 *      quizId: // value for 'quizId'
 *      learningModuleId: // value for 'learningModuleId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
function useAnswerQuizMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AnswerQuizDocument, options);
}
exports.ResetQuizDocument = (0, client_1.gql)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    mutation resetQuiz($quizId: String!, $learningModuleId: String!) {\n  resetQuiz(quizId: $quizId, learningModuleId: $learningModuleId)\n}\n    "], ["\n    mutation resetQuiz($quizId: String!, $learningModuleId: String!) {\n  resetQuiz(quizId: $quizId, learningModuleId: $learningModuleId)\n}\n    "])));
/**
 * __useResetQuizMutation__
 *
 * To run a mutation, you first call `useResetQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetQuizMutation, { data, loading, error }] = useResetQuizMutation({
 *   variables: {
 *      quizId: // value for 'quizId'
 *      learningModuleId: // value for 'learningModuleId'
 *   },
 * });
 */
function useResetQuizMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.ResetQuizDocument, options);
}
exports.CompleteLearningItemDocument = (0, client_1.gql)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    mutation completeLearningItem($learningModuleId: String!, $learningItemId: String!) {\n  completeLearningItem(\n    learningModuleId: $learningModuleId\n    learningItemId: $learningItemId\n  )\n}\n    "], ["\n    mutation completeLearningItem($learningModuleId: String!, $learningItemId: String!) {\n  completeLearningItem(\n    learningModuleId: $learningModuleId\n    learningItemId: $learningItemId\n  )\n}\n    "])));
/**
 * __useCompleteLearningItemMutation__
 *
 * To run a mutation, you first call `useCompleteLearningItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLearningItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLearningItemMutation, { data, loading, error }] = useCompleteLearningItemMutation({
 *   variables: {
 *      learningModuleId: // value for 'learningModuleId'
 *      learningItemId: // value for 'learningItemId'
 *   },
 * });
 */
function useCompleteLearningItemMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CompleteLearningItemDocument, options);
}
exports.UpdatePatientMealSelectionDocument = (0, client_1.gql)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    mutation updatePatientMealSelection($props: PatientMealSelectionInput!) {\n  updatePatientMealSelection(props: $props)\n}\n    "], ["\n    mutation updatePatientMealSelection($props: PatientMealSelectionInput!) {\n  updatePatientMealSelection(props: $props)\n}\n    "])));
/**
 * __useUpdatePatientMealSelectionMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMealSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMealSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMealSelectionMutation, { data, loading, error }] = useUpdatePatientMealSelectionMutation({
 *   variables: {
 *      props: // value for 'props'
 *   },
 * });
 */
function useUpdatePatientMealSelectionMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdatePatientMealSelectionDocument, options);
}
exports.UpdatePatientMealSelectionV2Document = (0, client_1.gql)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    mutation updatePatientMealSelectionV2($props: PatientMealSelectionInputV2!) {\n  updatePatientMealSelectionV2(props: $props)\n}\n    "], ["\n    mutation updatePatientMealSelectionV2($props: PatientMealSelectionInputV2!) {\n  updatePatientMealSelectionV2(props: $props)\n}\n    "])));
/**
 * __useUpdatePatientMealSelectionV2Mutation__
 *
 * To run a mutation, you first call `useUpdatePatientMealSelectionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMealSelectionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMealSelectionV2Mutation, { data, loading, error }] = useUpdatePatientMealSelectionV2Mutation({
 *   variables: {
 *      props: // value for 'props'
 *   },
 * });
 */
function useUpdatePatientMealSelectionV2Mutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdatePatientMealSelectionV2Document, options);
}
exports.ClearLearningBadgeDocument = (0, client_1.gql)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    mutation clearLearningBadge {\n  clearLearningBadge\n}\n    "], ["\n    mutation clearLearningBadge {\n  clearLearningBadge\n}\n    "])));
/**
 * __useClearLearningBadgeMutation__
 *
 * To run a mutation, you first call `useClearLearningBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearLearningBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearLearningBadgeMutation, { data, loading, error }] = useClearLearningBadgeMutation({
 *   variables: {
 *   },
 * });
 */
function useClearLearningBadgeMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.ClearLearningBadgeDocument, options);
}
exports.UpdatePreferencesDocument = (0, client_1.gql)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    mutation updatePreferences($prefs: UserPreferencesPatientInputV2!) {\n  preferencesV2(prefs: $prefs) {\n    notification {\n      chat {\n        enabled\n        type\n      }\n      learning {\n        enabled\n        type\n      }\n      survey {\n        enabled\n        type\n      }\n      meals {\n        enabled\n        type\n      }\n      documents {\n        enabled\n        type\n      }\n    }\n  }\n}\n    "], ["\n    mutation updatePreferences($prefs: UserPreferencesPatientInputV2!) {\n  preferencesV2(prefs: $prefs) {\n    notification {\n      chat {\n        enabled\n        type\n      }\n      learning {\n        enabled\n        type\n      }\n      survey {\n        enabled\n        type\n      }\n      meals {\n        enabled\n        type\n      }\n      documents {\n        enabled\n        type\n      }\n    }\n  }\n}\n    "])));
/**
 * __useUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferencesMutation, { data, loading, error }] = useUpdatePreferencesMutation({
 *   variables: {
 *      prefs: // value for 'prefs'
 *   },
 * });
 */
function useUpdatePreferencesMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdatePreferencesDocument, options);
}
exports.AddDocumentDocument = (0, client_1.gql)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    mutation addDocument($doc: AddDocumentInput!) {\n  addDocument(doc: $doc) {\n    document {\n      id\n      patient {\n        id\n        type\n        name\n      }\n      creator {\n        id\n        type\n        name\n      }\n      filename\n      filesize\n      created_at\n      updated_at\n      mimetype\n      is_patient_file\n      file_id\n    }\n    accessType\n    url\n    overwrite\n  }\n}\n    "], ["\n    mutation addDocument($doc: AddDocumentInput!) {\n  addDocument(doc: $doc) {\n    document {\n      id\n      patient {\n        id\n        type\n        name\n      }\n      creator {\n        id\n        type\n        name\n      }\n      filename\n      filesize\n      created_at\n      updated_at\n      mimetype\n      is_patient_file\n      file_id\n    }\n    accessType\n    url\n    overwrite\n  }\n}\n    "])));
/**
 * __useAddDocumentMutation__
 *
 * To run a mutation, you first call `useAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentMutation, { data, loading, error }] = useAddDocumentMutation({
 *   variables: {
 *      doc: // value for 'doc'
 *   },
 * });
 */
function useAddDocumentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AddDocumentDocument, options);
}
exports.DeleteDocumentDocument = (0, client_1.gql)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    mutation deleteDocument($id: ID!) {\n  deleteDocument(id: $id)\n}\n    "], ["\n    mutation deleteDocument($id: ID!) {\n  deleteDocument(id: $id)\n}\n    "])));
/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDeleteDocumentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.DeleteDocumentDocument, options);
}
exports.DeleteMeDocument = (0, client_1.gql)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    mutation deleteMe {\n  deleteMe\n}\n    "], ["\n    mutation deleteMe {\n  deleteMe\n}\n    "])));
/**
 * __useDeleteMeMutation__
 *
 * To run a mutation, you first call `useDeleteMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeMutation, { data, loading, error }] = useDeleteMeMutation({
 *   variables: {
 *   },
 * });
 */
function useDeleteMeMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.DeleteMeDocument, options);
}
exports.UpdateUserSessionInfoDocument = (0, client_1.gql)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    mutation updateUserSessionInfo($props: UserSessionInfoInput!) {\n  updateUserSessionInfo(props: $props)\n}\n    "], ["\n    mutation updateUserSessionInfo($props: UserSessionInfoInput!) {\n  updateUserSessionInfo(props: $props)\n}\n    "])));
/**
 * __useUpdateUserSessionInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserSessionInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSessionInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSessionInfoMutation, { data, loading, error }] = useUpdateUserSessionInfoMutation({
 *   variables: {
 *      props: // value for 'props'
 *   },
 * });
 */
function useUpdateUserSessionInfoMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateUserSessionInfoDocument, options);
}
exports.AnswerDataSurveyBhbDocument = (0, client_1.gql)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    mutation answerDataSurveyBhb($bhbData: BhbDataSurveyInput!) {\n  answerDataSurveyBhb(bhbData: $bhbData) {\n    bhb_value\n    instance_id\n    measured_at\n    timezone\n  }\n}\n    "], ["\n    mutation answerDataSurveyBhb($bhbData: BhbDataSurveyInput!) {\n  answerDataSurveyBhb(bhbData: $bhbData) {\n    bhb_value\n    instance_id\n    measured_at\n    timezone\n  }\n}\n    "])));
/**
 * __useAnswerDataSurveyBhbMutation__
 *
 * To run a mutation, you first call `useAnswerDataSurveyBhbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerDataSurveyBhbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerDataSurveyBhbMutation, { data, loading, error }] = useAnswerDataSurveyBhbMutation({
 *   variables: {
 *      bhbData: // value for 'bhbData'
 *   },
 * });
 */
function useAnswerDataSurveyBhbMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AnswerDataSurveyBhbDocument, options);
}
exports.AnswerAnytimeSurveyForSubjectDocument = (0, client_1.gql)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    mutation answerAnytimeSurveyForSubject($surveyId: ID!, $answers: [SurveyQuestionAnswerInput!]!, $respondedAt: DateTime!, $respondedAtTz: String!) {\n  answerAnytimeSurveyForSubject(\n    surveyId: $surveyId\n    answers: $answers\n    respondedAt: $respondedAt\n    respondedAtTz: $respondedAtTz\n  )\n}\n    "], ["\n    mutation answerAnytimeSurveyForSubject($surveyId: ID!, $answers: [SurveyQuestionAnswerInput!]!, $respondedAt: DateTime!, $respondedAtTz: String!) {\n  answerAnytimeSurveyForSubject(\n    surveyId: $surveyId\n    answers: $answers\n    respondedAt: $respondedAt\n    respondedAtTz: $respondedAtTz\n  )\n}\n    "])));
/**
 * __useAnswerAnytimeSurveyForSubjectMutation__
 *
 * To run a mutation, you first call `useAnswerAnytimeSurveyForSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerAnytimeSurveyForSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerAnytimeSurveyForSubjectMutation, { data, loading, error }] = useAnswerAnytimeSurveyForSubjectMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      answers: // value for 'answers'
 *      respondedAt: // value for 'respondedAt'
 *      respondedAtTz: // value for 'respondedAtTz'
 *   },
 * });
 */
function useAnswerAnytimeSurveyForSubjectMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AnswerAnytimeSurveyForSubjectDocument, options);
}
exports.GetApiKeysDocument = (0, client_1.gql)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    query getApiKeys {\n  apiKeys {\n    segmentTracker\n    segmentTrackerWeb\n    facebookAppId\n  }\n}\n    "], ["\n    query getApiKeys {\n  apiKeys {\n    segmentTracker\n    segmentTrackerWeb\n    facebookAppId\n  }\n}\n    "])));
/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
function useGetApiKeysQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetApiKeysDocument, options);
}
function useGetApiKeysLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetApiKeysDocument, options);
}
exports.GetEnvironmentNameDocument = (0, client_1.gql)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    query getEnvironmentName {\n  environmentName\n}\n    "], ["\n    query getEnvironmentName {\n  environmentName\n}\n    "])));
/**
 * __useGetEnvironmentNameQuery__
 *
 * To run a query within a React component, call `useGetEnvironmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvironmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvironmentNameQuery({
 *   variables: {
 *   },
 * });
 */
function useGetEnvironmentNameQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetEnvironmentNameDocument, options);
}
function useGetEnvironmentNameLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetEnvironmentNameDocument, options);
}
exports.GetLearningModuleDocument = (0, client_1.gql)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    query getLearningModule($learningModuleId: String!, $contentfulEnv: String) {\n  learningModule(\n    learningModuleId: $learningModuleId\n    contentfulEnv: $contentfulEnv\n  ) {\n    id\n    title\n    description\n    image\n    is_assigned\n    status\n    assignType\n    itemsStatus {\n      itemId\n      completed\n    }\n    lockLearningItems\n    learningItems {\n      id\n      title\n      externalContent\n      content\n      quiz {\n        id\n        title\n        questions {\n          id\n          quizId\n          question\n          options\n          correctAnswers\n          userAnswers\n        }\n      }\n    }\n    quiz {\n      id\n      title\n      questions {\n        id\n        quizId\n        question\n        options\n        correctAnswers\n        userAnswers\n      }\n    }\n  }\n}\n    "], ["\n    query getLearningModule($learningModuleId: String!, $contentfulEnv: String) {\n  learningModule(\n    learningModuleId: $learningModuleId\n    contentfulEnv: $contentfulEnv\n  ) {\n    id\n    title\n    description\n    image\n    is_assigned\n    status\n    assignType\n    itemsStatus {\n      itemId\n      completed\n    }\n    lockLearningItems\n    learningItems {\n      id\n      title\n      externalContent\n      content\n      quiz {\n        id\n        title\n        questions {\n          id\n          quizId\n          question\n          options\n          correctAnswers\n          userAnswers\n        }\n      }\n    }\n    quiz {\n      id\n      title\n      questions {\n        id\n        quizId\n        question\n        options\n        correctAnswers\n        userAnswers\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetLearningModuleQuery__
 *
 * To run a query within a React component, call `useGetLearningModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningModuleQuery({
 *   variables: {
 *      learningModuleId: // value for 'learningModuleId'
 *      contentfulEnv: // value for 'contentfulEnv'
 *   },
 * });
 */
function useGetLearningModuleQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetLearningModuleDocument, options);
}
function useGetLearningModuleLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetLearningModuleDocument, options);
}
exports.GetLearningModulesDocument = (0, client_1.gql)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    query getLearningModules($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  learningModules(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        title\n        image\n        assigned_on\n        is_assigned\n        status\n        assignType\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query getLearningModules($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  learningModules(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        title\n        image\n        assigned_on\n        is_assigned\n        status\n        assignType\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useGetLearningModulesQuery__
 *
 * To run a query within a React component, call `useGetLearningModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningModulesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useGetLearningModulesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetLearningModulesDocument, options);
}
function useGetLearningModulesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetLearningModulesDocument, options);
}
exports.GetProfileDocument = (0, client_1.gql)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    query getProfile {\n  me {\n    id\n    type\n    email\n    created_at\n    phone_number\n    name\n    birthdate\n    picture\n    is_learn_active\n    gapi_refresh_token\n    timezone\n    language\n    subjectTrialStatus\n    eligibleForHomeCooked\n    coach {\n      id\n      email\n      phone_number\n      name\n      birthdate\n      picture\n      description\n    }\n    backup_coach {\n      id\n      email\n      phone_number\n      name\n      birthdate\n      picture\n      description\n    }\n    address {\n      formatted\n      street_address\n      locality\n      region\n      postal_code\n      country\n      complement\n    }\n    is_ct\n    last_in_app_review\n    main_goal\n  }\n}\n    "], ["\n    query getProfile {\n  me {\n    id\n    type\n    email\n    created_at\n    phone_number\n    name\n    birthdate\n    picture\n    is_learn_active\n    gapi_refresh_token\n    timezone\n    language\n    subjectTrialStatus\n    eligibleForHomeCooked\n    coach {\n      id\n      email\n      phone_number\n      name\n      birthdate\n      picture\n      description\n    }\n    backup_coach {\n      id\n      email\n      phone_number\n      name\n      birthdate\n      picture\n      description\n    }\n    address {\n      formatted\n      street_address\n      locality\n      region\n      postal_code\n      country\n      complement\n    }\n    is_ct\n    last_in_app_review\n    main_goal\n  }\n}\n    "])));
/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
function useGetProfileQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetProfileDocument, options);
}
function useGetProfileLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetProfileDocument, options);
}
exports.IsCtPresignupDocument = (0, client_1.gql)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    query isCtPresignup($email: String!) {\n  isCtPresignup(email: $email) {\n    is_ct\n  }\n}\n    "], ["\n    query isCtPresignup($email: String!) {\n  isCtPresignup(email: $email) {\n    is_ct\n  }\n}\n    "])));
/**
 * __useIsCtPresignupQuery__
 *
 * To run a query within a React component, call `useIsCtPresignupQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCtPresignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCtPresignupQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
function useIsCtPresignupQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.IsCtPresignupDocument, options);
}
function useIsCtPresignupLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.IsCtPresignupDocument, options);
}
exports.GetArticlesDocument = (0, client_1.gql)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    query getArticles($offset: Int = 0, $limit: Int = 10) {\n  articles(offset: $offset, limit: $limit) {\n    id\n    title\n    coverImage\n    createdBy\n    content\n    publishedAt\n    url\n  }\n}\n    "], ["\n    query getArticles($offset: Int = 0, $limit: Int = 10) {\n  articles(offset: $offset, limit: $limit) {\n    id\n    title\n    coverImage\n    createdBy\n    content\n    publishedAt\n    url\n  }\n}\n    "])));
/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
function useGetArticlesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetArticlesDocument, options);
}
function useGetArticlesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetArticlesDocument, options);
}
exports.GetAvailableSurveysDocument = (0, client_1.gql)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    query getAvailableSurveys($first: Int = 1000, $showDataSurveys: Boolean, $version: Int) {\n  availableSurveys(\n    first: $first\n    showDataSurveys: $showDataSurveys\n    version: $version\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        surveyId\n        name\n        due_at\n        status\n        completed_at\n        instanceType\n        requires_confirmation\n        schedule {\n          starts_at\n          frequency\n          weekDays\n          complete_within_days\n          timezone\n        }\n        questions {\n          id\n          type\n          title\n          helpText\n          placeholderText\n          maxLength\n          required\n          possibleAnswers\n          possibleAnswersIcons\n          possibleAnswersDescriptions\n          footnote\n          answer\n          logic {\n            conditionQuestion {\n              value\n              index\n              type\n            }\n            condition\n            conditionAnswer\n            action\n          }\n          customPropsOfType {\n            ... on ExplanationProps {\n              headerAsset\n              content {\n                type\n                data\n              }\n            }\n            ... on DecimalProps {\n              min\n              max\n              unit\n              numberOfDecimals\n            }\n          }\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    isBeforeFirstSurvey\n  }\n}\n    "], ["\n    query getAvailableSurveys($first: Int = 1000, $showDataSurveys: Boolean, $version: Int) {\n  availableSurveys(\n    first: $first\n    showDataSurveys: $showDataSurveys\n    version: $version\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        surveyId\n        name\n        due_at\n        status\n        completed_at\n        instanceType\n        requires_confirmation\n        schedule {\n          starts_at\n          frequency\n          weekDays\n          complete_within_days\n          timezone\n        }\n        questions {\n          id\n          type\n          title\n          helpText\n          placeholderText\n          maxLength\n          required\n          possibleAnswers\n          possibleAnswersIcons\n          possibleAnswersDescriptions\n          footnote\n          answer\n          logic {\n            conditionQuestion {\n              value\n              index\n              type\n            }\n            condition\n            conditionAnswer\n            action\n          }\n          customPropsOfType {\n            ... on ExplanationProps {\n              headerAsset\n              content {\n                type\n                data\n              }\n            }\n            ... on DecimalProps {\n              min\n              max\n              unit\n              numberOfDecimals\n            }\n          }\n        }\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    isBeforeFirstSurvey\n  }\n}\n    "])));
/**
 * __useGetAvailableSurveysQuery__
 *
 * To run a query within a React component, call `useGetAvailableSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSurveysQuery({
 *   variables: {
 *      first: // value for 'first'
 *      showDataSurveys: // value for 'showDataSurveys'
 *      version: // value for 'version'
 *   },
 * });
 */
function useGetAvailableSurveysQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetAvailableSurveysDocument, options);
}
function useGetAvailableSurveysLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetAvailableSurveysDocument, options);
}
exports.GetFaQsDocument = (0, client_1.gql)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    query getFAQs($categoryId: String) {\n  faqs(categoryId: $categoryId) {\n    id\n    question\n    answer\n    category\n  }\n}\n    "], ["\n    query getFAQs($categoryId: String) {\n  faqs(categoryId: $categoryId) {\n    id\n    question\n    answer\n    category\n  }\n}\n    "])));
/**
 * __useGetFaQsQuery__
 *
 * To run a query within a React component, call `useGetFaQsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaQsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaQsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
function useGetFaQsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetFaQsDocument, options);
}
function useGetFaQsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetFaQsDocument, options);
}
exports.GetFeatureFlagsDocument = (0, client_1.gql)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    query getFeatureFlags {\n  featureFlags {\n    name\n    type\n    enabled\n  }\n}\n    "], ["\n    query getFeatureFlags {\n  featureFlags {\n    name\n    type\n    enabled\n  }\n}\n    "])));
/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
function useGetFeatureFlagsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetFeatureFlagsDocument, options);
}
function useGetFeatureFlagsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetFeatureFlagsDocument, options);
}
exports.CountNewLearningAssignmentsDocument = (0, client_1.gql)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    query countNewLearningAssignments {\n  newLearningAssignments\n}\n    "], ["\n    query countNewLearningAssignments {\n  newLearningAssignments\n}\n    "])));
/**
 * __useCountNewLearningAssignmentsQuery__
 *
 * To run a query within a React component, call `useCountNewLearningAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountNewLearningAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountNewLearningAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
function useCountNewLearningAssignmentsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.CountNewLearningAssignmentsDocument, options);
}
function useCountNewLearningAssignmentsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.CountNewLearningAssignmentsDocument, options);
}
exports.GetPreferencesDocument = (0, client_1.gql)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    query getPreferences {\n  preferencesV2 {\n    notification {\n      chat {\n        enabled\n        type\n      }\n      learning {\n        enabled\n        type\n      }\n      survey {\n        enabled\n        type\n      }\n      meals {\n        enabled\n        type\n      }\n      documents {\n        enabled\n        type\n      }\n    }\n  }\n}\n    "], ["\n    query getPreferences {\n  preferencesV2 {\n    notification {\n      chat {\n        enabled\n        type\n      }\n      learning {\n        enabled\n        type\n      }\n      survey {\n        enabled\n        type\n      }\n      meals {\n        enabled\n        type\n      }\n      documents {\n        enabled\n        type\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetPreferencesQuery__
 *
 * To run a query within a React component, call `useGetPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
function useGetPreferencesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetPreferencesDocument, options);
}
function useGetPreferencesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetPreferencesDocument, options);
}
exports.GetDocumentInfoDocument = (0, client_1.gql)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    query getDocumentInfo($id: ID!) {\n  document(id: $id) {\n    id\n    patient {\n      id\n      type\n      name\n    }\n    creator {\n      id\n      type\n      name\n    }\n    filename\n    filesize\n    created_at\n    updated_at\n    mimetype\n    is_patient_file\n    file_id\n  }\n}\n    "], ["\n    query getDocumentInfo($id: ID!) {\n  document(id: $id) {\n    id\n    patient {\n      id\n      type\n      name\n    }\n    creator {\n      id\n      type\n      name\n    }\n    filename\n    filesize\n    created_at\n    updated_at\n    mimetype\n    is_patient_file\n    file_id\n  }\n}\n    "])));
/**
 * __useGetDocumentInfoQuery__
 *
 * To run a query within a React component, call `useGetDocumentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetDocumentInfoQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDocumentInfoDocument, options);
}
function useGetDocumentInfoLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDocumentInfoDocument, options);
}
exports.ListDocumentsDocument = (0, client_1.gql)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    query listDocuments($first: Int = 30, $after: String, $filterBy: FilterBy, $sortBy: SortBy, $ownerFilter: DocumentOwnerFilter!) {\n  documents(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n    ownerFilter: $ownerFilter\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        patient {\n          id\n          type\n          name\n        }\n        creator {\n          id\n          type\n          name\n        }\n        filename\n        filesize\n        created_at\n        updated_at\n        mimetype\n        is_patient_file\n        file_id\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n    "], ["\n    query listDocuments($first: Int = 30, $after: String, $filterBy: FilterBy, $sortBy: SortBy, $ownerFilter: DocumentOwnerFilter!) {\n  documents(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n    ownerFilter: $ownerFilter\n  ) {\n    edges {\n      cursor\n      node {\n        id\n        patient {\n          id\n          type\n          name\n        }\n        creator {\n          id\n          type\n          name\n        }\n        filename\n        filesize\n        created_at\n        updated_at\n        mimetype\n        is_patient_file\n        file_id\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n    "])));
/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *      ownerFilter: // value for 'ownerFilter'
 *   },
 * });
 */
function useListDocumentsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListDocumentsDocument, options);
}
function useListDocumentsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListDocumentsDocument, options);
}
exports.GetDocumentCountsDocument = (0, client_1.gql)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    query getDocumentCounts {\n  documentCounts {\n    coach\n    patient\n  }\n}\n    "], ["\n    query getDocumentCounts {\n  documentCounts {\n    coach\n    patient\n  }\n}\n    "])));
/**
 * __useGetDocumentCountsQuery__
 *
 * To run a query within a React component, call `useGetDocumentCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCountsQuery({
 *   variables: {
 *   },
 * });
 */
function useGetDocumentCountsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDocumentCountsDocument, options);
}
function useGetDocumentCountsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDocumentCountsDocument, options);
}
exports.DownloadDocumentDocument = (0, client_1.gql)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    query downloadDocument($id: ID!) {\n  downloadDocument(id: $id) {\n    document {\n      id\n      patient {\n        id\n        type\n        name\n      }\n      creator {\n        id\n        type\n        name\n      }\n      filename\n      filesize\n      created_at\n      updated_at\n      mimetype\n      is_patient_file\n      file_id\n    }\n    accessType\n    url\n  }\n}\n    "], ["\n    query downloadDocument($id: ID!) {\n  downloadDocument(id: $id) {\n    document {\n      id\n      patient {\n        id\n        type\n        name\n      }\n      creator {\n        id\n        type\n        name\n      }\n      filename\n      filesize\n      created_at\n      updated_at\n      mimetype\n      is_patient_file\n      file_id\n    }\n    accessType\n    url\n  }\n}\n    "])));
/**
 * __useDownloadDocumentQuery__
 *
 * To run a query within a React component, call `useDownloadDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDownloadDocumentQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.DownloadDocumentDocument, options);
}
function useDownloadDocumentLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.DownloadDocumentDocument, options);
}
exports.GetDishDocument = (0, client_1.gql)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    query getDish($id: ID!) {\n  dish(id: $id) {\n    id\n    name\n    photoUrl\n    description\n    ingredients\n    nutritionalValuesUrl\n    tags {\n      id\n      name\n      icon\n      color\n      borderColor\n      isPinned\n    }\n    instructions\n  }\n}\n    "], ["\n    query getDish($id: ID!) {\n  dish(id: $id) {\n    id\n    name\n    photoUrl\n    description\n    ingredients\n    nutritionalValuesUrl\n    tags {\n      id\n      name\n      icon\n      color\n      borderColor\n      isPinned\n    }\n    instructions\n  }\n}\n    "])));
/**
 * __useGetDishQuery__
 *
 * To run a query within a React component, call `useGetDishQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetDishQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDishDocument, options);
}
function useGetDishLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDishDocument, options);
}
exports.GetMenuOptionSelectionsDocument = (0, client_1.gql)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    query getMenuOptionSelections($dietPlanDeliveryMenuId: ID!) {\n  menuOptionSelectionV2(dietPlanDeliveryMenuId: $dietPlanDeliveryMenuId) {\n    amount\n    amountPerDay\n    snackAmount\n    breakfast {\n      ...Option\n    }\n    dinner {\n      ...Option\n    }\n    lunch {\n      ...Option\n    }\n    snacks {\n      ...Option\n    }\n    sides {\n      ...Option\n    }\n  }\n}\n    ", ""], ["\n    query getMenuOptionSelections($dietPlanDeliveryMenuId: ID!) {\n  menuOptionSelectionV2(dietPlanDeliveryMenuId: $dietPlanDeliveryMenuId) {\n    amount\n    amountPerDay\n    snackAmount\n    breakfast {\n      ...Option\n    }\n    dinner {\n      ...Option\n    }\n    lunch {\n      ...Option\n    }\n    snacks {\n      ...Option\n    }\n    sides {\n      ...Option\n    }\n  }\n}\n    ", ""])), exports.OptionFragmentDoc);
/**
 * __useGetMenuOptionSelectionsQuery__
 *
 * To run a query within a React component, call `useGetMenuOptionSelectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuOptionSelectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuOptionSelectionsQuery({
 *   variables: {
 *      dietPlanDeliveryMenuId: // value for 'dietPlanDeliveryMenuId'
 *   },
 * });
 */
function useGetMenuOptionSelectionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetMenuOptionSelectionsDocument, options);
}
function useGetMenuOptionSelectionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetMenuOptionSelectionsDocument, options);
}
exports.ListDeliveriesDocument = (0, client_1.gql)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    query listDeliveries($date: String!) {\n  deliveries(date: $date) {\n    id\n    food_program_id\n    delivery_menu_id\n    delivery_key\n    delivery_date\n    open_changes\n    status\n    is_canceled\n  }\n}\n    "], ["\n    query listDeliveries($date: String!) {\n  deliveries(date: $date) {\n    id\n    food_program_id\n    delivery_menu_id\n    delivery_key\n    delivery_date\n    open_changes\n    status\n    is_canceled\n  }\n}\n    "])));
/**
 * __useListDeliveriesQuery__
 *
 * To run a query within a React component, call `useListDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeliveriesQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
function useListDeliveriesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListDeliveriesDocument, options);
}
function useListDeliveriesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListDeliveriesDocument, options);
}
exports.ListDeliveriesV2Document = (0, client_1.gql)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    query listDeliveriesV2($date: String!) {\n  deliveriesV2(date: $date) {\n    id\n    foodProgramUser {\n      id\n      patient {\n        id\n        name\n        subject_id\n      }\n      dietPlan {\n        id\n        name\n      }\n      status\n    }\n    dietPlanDeliveryMenu {\n      id\n      name\n      description\n      sequenceNumber\n      deliveryDayOfWeek\n      quantity\n      menu {\n        id\n        name\n        createdAt\n        updatedAt\n        breakfast\n        lunch\n        dinner\n        snacks\n        sides\n      }\n    }\n    order {\n      id\n      name\n      shipmentLabels {\n        id\n        trackingNumber\n        trackingUrl\n        trackingStatus\n        shipmentLabelStatus\n        eta\n      }\n    }\n    deliveryDate\n    openChanges\n    status\n    isCanceled\n    daysCovered\n    weekdaysCovered\n  }\n}\n    "], ["\n    query listDeliveriesV2($date: String!) {\n  deliveriesV2(date: $date) {\n    id\n    foodProgramUser {\n      id\n      patient {\n        id\n        name\n        subject_id\n      }\n      dietPlan {\n        id\n        name\n      }\n      status\n    }\n    dietPlanDeliveryMenu {\n      id\n      name\n      description\n      sequenceNumber\n      deliveryDayOfWeek\n      quantity\n      menu {\n        id\n        name\n        createdAt\n        updatedAt\n        breakfast\n        lunch\n        dinner\n        snacks\n        sides\n      }\n    }\n    order {\n      id\n      name\n      shipmentLabels {\n        id\n        trackingNumber\n        trackingUrl\n        trackingStatus\n        shipmentLabelStatus\n        eta\n      }\n    }\n    deliveryDate\n    openChanges\n    status\n    isCanceled\n    daysCovered\n    weekdaysCovered\n  }\n}\n    "])));
/**
 * __useListDeliveriesV2Query__
 *
 * To run a query within a React component, call `useListDeliveriesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListDeliveriesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeliveriesV2Query({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
function useListDeliveriesV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListDeliveriesV2Document, options);
}
function useListDeliveriesV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListDeliveriesV2Document, options);
}
exports.GetFoodProgramUserDocument = (0, client_1.gql)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    query getFoodProgramUser {\n  foodProgramUser {\n    id\n    patient {\n      id\n      name\n      subject_id\n    }\n    diet_plan {\n      id\n      name\n    }\n    status\n    weekdaysOnDietWeekA\n    weekdaysOnDietWeekB\n    weekdays_on_diet\n    snacks_per_day\n  }\n}\n    "], ["\n    query getFoodProgramUser {\n  foodProgramUser {\n    id\n    patient {\n      id\n      name\n      subject_id\n    }\n    diet_plan {\n      id\n      name\n    }\n    status\n    weekdaysOnDietWeekA\n    weekdaysOnDietWeekB\n    weekdays_on_diet\n    snacks_per_day\n  }\n}\n    "])));
/**
 * __useGetFoodProgramUserQuery__
 *
 * To run a query within a React component, call `useGetFoodProgramUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodProgramUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodProgramUserQuery({
 *   variables: {
 *   },
 * });
 */
function useGetFoodProgramUserQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetFoodProgramUserDocument, options);
}
function useGetFoodProgramUserLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetFoodProgramUserDocument, options);
}
exports.GetFoodProgramUserV2Document = (0, client_1.gql)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    query getFoodProgramUserV2 {\n  foodProgramUserV2 {\n    id\n    patient {\n      id\n      name\n      subject_id\n    }\n    dietPlan {\n      id\n      name\n    }\n    status\n    deliverySettings\n    userDeliveryMenus {\n      id\n      snacksPerDay\n      sachetsPerDay\n      mealsPerDay\n      weekdaysOnDiet\n      dietPlanDeliveryMenu {\n        id\n        name\n        description\n        sequenceNumber\n        deliveryDayOfWeek\n        quantity\n        type\n        isInScheduler\n        menu {\n          id\n          name\n          createdAt\n          updatedAt\n          breakfast\n          lunch\n          dinner\n          snacks\n          sides\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query getFoodProgramUserV2 {\n  foodProgramUserV2 {\n    id\n    patient {\n      id\n      name\n      subject_id\n    }\n    dietPlan {\n      id\n      name\n    }\n    status\n    deliverySettings\n    userDeliveryMenus {\n      id\n      snacksPerDay\n      sachetsPerDay\n      mealsPerDay\n      weekdaysOnDiet\n      dietPlanDeliveryMenu {\n        id\n        name\n        description\n        sequenceNumber\n        deliveryDayOfWeek\n        quantity\n        type\n        isInScheduler\n        menu {\n          id\n          name\n          createdAt\n          updatedAt\n          breakfast\n          lunch\n          dinner\n          snacks\n          sides\n        }\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetFoodProgramUserV2Query__
 *
 * To run a query within a React component, call `useGetFoodProgramUserV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodProgramUserV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodProgramUserV2Query({
 *   variables: {
 *   },
 * });
 */
function useGetFoodProgramUserV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetFoodProgramUserV2Document, options);
}
function useGetFoodProgramUserV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetFoodProgramUserV2Document, options);
}
exports.GetSelectedMenuOptionsDocument = (0, client_1.gql)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    query getSelectedMenuOptions($deliveryId: ID!) {\n  selectedMenuOptions(deliveryId: $deliveryId) {\n    breakfast {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    lunch {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    dinner {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    snacks {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    sides {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n  }\n}\n    "], ["\n    query getSelectedMenuOptions($deliveryId: ID!) {\n  selectedMenuOptions(deliveryId: $deliveryId) {\n    breakfast {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    lunch {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    dinner {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    snacks {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n    sides {\n      menuOptionId\n      dishId\n      name\n      photoUrl\n      quantity\n      type\n    }\n  }\n}\n    "])));
/**
 * __useGetSelectedMenuOptionsQuery__
 *
 * To run a query within a React component, call `useGetSelectedMenuOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedMenuOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedMenuOptionsQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
function useGetSelectedMenuOptionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetSelectedMenuOptionsDocument, options);
}
function useGetSelectedMenuOptionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetSelectedMenuOptionsDocument, options);
}
exports.GetSelectedMenuOptionsV2Document = (0, client_1.gql)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    query getSelectedMenuOptionsV2($deliveryId: ID!) {\n  selectedMenuOptionsV2(deliveryId: $deliveryId) {\n    breakfast {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    lunch {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    dinner {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    snacks {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    sides {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n  }\n}\n    "], ["\n    query getSelectedMenuOptionsV2($deliveryId: ID!) {\n  selectedMenuOptionsV2(deliveryId: $deliveryId) {\n    breakfast {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    lunch {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    dinner {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    snacks {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n    sides {\n      dishId\n      referenceId\n      name\n      photoUrl\n      quantity\n      type\n      mealOptionType\n      mealkitVariantId\n      mealkitVariantIngredientName\n    }\n  }\n}\n    "])));
/**
 * __useGetSelectedMenuOptionsV2Query__
 *
 * To run a query within a React component, call `useGetSelectedMenuOptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedMenuOptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedMenuOptionsV2Query({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
function useGetSelectedMenuOptionsV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetSelectedMenuOptionsV2Document, options);
}
function useGetSelectedMenuOptionsV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetSelectedMenuOptionsV2Document, options);
}
exports.GetArticleTokenDocument = (0, client_1.gql)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    query getArticleToken {\n  articleToken\n}\n    "], ["\n    query getArticleToken {\n  articleToken\n}\n    "])));
/**
 * __useGetArticleTokenQuery__
 *
 * To run a query within a React component, call `useGetArticleTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleTokenQuery({
 *   variables: {
 *   },
 * });
 */
function useGetArticleTokenQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetArticleTokenDocument, options);
}
function useGetArticleTokenLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetArticleTokenDocument, options);
}
exports.GetCryptoKeyDocument = (0, client_1.gql)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    query getCryptoKey {\n  cryptoKey\n}\n    "], ["\n    query getCryptoKey {\n  cryptoKey\n}\n    "])));
/**
 * __useGetCryptoKeyQuery__
 *
 * To run a query within a React component, call `useGetCryptoKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCryptoKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCryptoKeyQuery({
 *   variables: {
 *   },
 * });
 */
function useGetCryptoKeyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetCryptoKeyDocument, options);
}
function useGetCryptoKeyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetCryptoKeyDocument, options);
}
exports.GetDeliveryDocument = (0, client_1.gql)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n    query getDelivery($deliveryId: ID!) {\n  delivery(deliveryId: $deliveryId) {\n    id\n    delivery_date\n  }\n}\n    "], ["\n    query getDelivery($deliveryId: ID!) {\n  delivery(deliveryId: $deliveryId) {\n    id\n    delivery_date\n  }\n}\n    "])));
/**
 * __useGetDeliveryQuery__
 *
 * To run a query within a React component, call `useGetDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
function useGetDeliveryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDeliveryDocument, options);
}
function useGetDeliveryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDeliveryDocument, options);
}
exports.GetDeliveryV2Document = (0, client_1.gql)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    query getDeliveryV2($deliveryId: ID!) {\n  deliveryV2(deliveryId: $deliveryId) {\n    id\n    foodProgramUser {\n      id\n      patient {\n        id\n        name\n        subject_id\n      }\n      dietPlan {\n        id\n        name\n      }\n      status\n      deliverySettings\n      userDeliveryMenus {\n        id\n        snacksPerDay\n        sachetsPerDay\n        mealsPerDay\n        weekdaysOnDiet\n        dietPlanDeliveryMenu {\n          id\n          name\n          description\n          sequenceNumber\n          deliveryDayOfWeek\n          quantity\n          menu {\n            id\n            name\n            createdAt\n            updatedAt\n            breakfast\n            lunch\n            dinner\n            snacks\n            sides\n          }\n        }\n      }\n    }\n    dietPlanDeliveryMenu {\n      id\n      name\n      description\n      sequenceNumber\n      deliveryDayOfWeek\n      quantity\n      menu {\n        id\n        name\n        createdAt\n        updatedAt\n        breakfast\n        lunch\n        dinner\n        snacks\n        sides\n      }\n    }\n    order {\n      id\n      name\n      shipmentLabels {\n        id\n        trackingNumber\n        trackingUrl\n        trackingStatus\n        shipmentLabelStatus\n        eta\n      }\n    }\n    deliveryDate\n    openChanges\n    status\n    isCanceled\n    daysCovered\n    weekdaysCovered\n  }\n}\n    "], ["\n    query getDeliveryV2($deliveryId: ID!) {\n  deliveryV2(deliveryId: $deliveryId) {\n    id\n    foodProgramUser {\n      id\n      patient {\n        id\n        name\n        subject_id\n      }\n      dietPlan {\n        id\n        name\n      }\n      status\n      deliverySettings\n      userDeliveryMenus {\n        id\n        snacksPerDay\n        sachetsPerDay\n        mealsPerDay\n        weekdaysOnDiet\n        dietPlanDeliveryMenu {\n          id\n          name\n          description\n          sequenceNumber\n          deliveryDayOfWeek\n          quantity\n          menu {\n            id\n            name\n            createdAt\n            updatedAt\n            breakfast\n            lunch\n            dinner\n            snacks\n            sides\n          }\n        }\n      }\n    }\n    dietPlanDeliveryMenu {\n      id\n      name\n      description\n      sequenceNumber\n      deliveryDayOfWeek\n      quantity\n      menu {\n        id\n        name\n        createdAt\n        updatedAt\n        breakfast\n        lunch\n        dinner\n        snacks\n        sides\n      }\n    }\n    order {\n      id\n      name\n      shipmentLabels {\n        id\n        trackingNumber\n        trackingUrl\n        trackingStatus\n        shipmentLabelStatus\n        eta\n      }\n    }\n    deliveryDate\n    openChanges\n    status\n    isCanceled\n    daysCovered\n    weekdaysCovered\n  }\n}\n    "])));
/**
 * __useGetDeliveryV2Query__
 *
 * To run a query within a React component, call `useGetDeliveryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryV2Query({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
function useGetDeliveryV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDeliveryV2Document, options);
}
function useGetDeliveryV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDeliveryV2Document, options);
}
exports.GetSurveyInstanceDocument = (0, client_1.gql)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n    query getSurveyInstance($instanceId: ID!, $showDataSurveys: Boolean) {\n  surveyInstance(instanceId: $instanceId, showDataSurveys: $showDataSurveys) {\n    id\n    surveyId\n    name\n    due_at\n    status\n    completed_at\n    instanceType\n    requires_confirmation\n    questions {\n      id\n      type\n      title\n      helpText\n      placeholderText\n      maxLength\n      required\n      possibleAnswers\n      possibleAnswersIcons\n      possibleAnswersDescriptions\n      footnote\n      answer\n      logic {\n        conditionQuestion {\n          value\n          index\n          type\n        }\n        condition\n        conditionAnswer\n        action\n      }\n      customPropsOfType {\n        ... on ExplanationProps {\n          headerAsset\n          content {\n            type\n            data\n          }\n        }\n        ... on DecimalProps {\n          min\n          max\n          unit\n          numberOfDecimals\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query getSurveyInstance($instanceId: ID!, $showDataSurveys: Boolean) {\n  surveyInstance(instanceId: $instanceId, showDataSurveys: $showDataSurveys) {\n    id\n    surveyId\n    name\n    due_at\n    status\n    completed_at\n    instanceType\n    requires_confirmation\n    questions {\n      id\n      type\n      title\n      helpText\n      placeholderText\n      maxLength\n      required\n      possibleAnswers\n      possibleAnswersIcons\n      possibleAnswersDescriptions\n      footnote\n      answer\n      logic {\n        conditionQuestion {\n          value\n          index\n          type\n        }\n        condition\n        conditionAnswer\n        action\n      }\n      customPropsOfType {\n        ... on ExplanationProps {\n          headerAsset\n          content {\n            type\n            data\n          }\n        }\n        ... on DecimalProps {\n          min\n          max\n          unit\n          numberOfDecimals\n        }\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetSurveyInstanceQuery__
 *
 * To run a query within a React component, call `useGetSurveyInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyInstanceQuery({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      showDataSurveys: // value for 'showDataSurveys'
 *   },
 * });
 */
function useGetSurveyInstanceQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetSurveyInstanceDocument, options);
}
function useGetSurveyInstanceLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetSurveyInstanceDocument, options);
}
exports.GetInfoForAnalyticsDocument = (0, client_1.gql)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    query getInfoForAnalytics {\n  user: me {\n    userType: type\n    userId: id\n  }\n  keys: apiKeys {\n    analyticsKey: segmentTrackerWeb\n  }\n  environment: environmentName\n}\n    "], ["\n    query getInfoForAnalytics {\n  user: me {\n    userType: type\n    userId: id\n  }\n  keys: apiKeys {\n    analyticsKey: segmentTrackerWeb\n  }\n  environment: environmentName\n}\n    "])));
/**
 * __useGetInfoForAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetInfoForAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoForAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoForAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
function useGetInfoForAnalyticsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetInfoForAnalyticsDocument, options);
}
function useGetInfoForAnalyticsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetInfoForAnalyticsDocument, options);
}
exports.GetMyDietPlanDishesHistoryDocument = (0, client_1.gql)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n    query getMyDietPlanDishesHistory($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  dietPlanDishesHistory(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        name\n        photoUrl\n        type\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query getMyDietPlanDishesHistory($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  dietPlanDishesHistory(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        name\n        photoUrl\n        type\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useGetMyDietPlanDishesHistoryQuery__
 *
 * To run a query within a React component, call `useGetMyDietPlanDishesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDietPlanDishesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDietPlanDishesHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useGetMyDietPlanDishesHistoryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetMyDietPlanDishesHistoryDocument, options);
}
function useGetMyDietPlanDishesHistoryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetMyDietPlanDishesHistoryDocument, options);
}
exports.GetMyDietPlanDishesHistoryV2Document = (0, client_1.gql)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n    query getMyDietPlanDishesHistoryV2($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  dietPlanDishesHistoryV2(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        name\n        photoUrl\n        type\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query getMyDietPlanDishesHistoryV2($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  dietPlanDishesHistoryV2(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        name\n        photoUrl\n        type\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useGetMyDietPlanDishesHistoryV2Query__
 *
 * To run a query within a React component, call `useGetMyDietPlanDishesHistoryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDietPlanDishesHistoryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDietPlanDishesHistoryV2Query({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useGetMyDietPlanDishesHistoryV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetMyDietPlanDishesHistoryV2Document, options);
}
function useGetMyDietPlanDishesHistoryV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetMyDietPlanDishesHistoryV2Document, options);
}
exports.GetLastAssayResultsDocument = (0, client_1.gql)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n    query getLastAssayResults {\n  lastAssayResults {\n    id\n    indicatorId\n    name\n    value\n    eventDate\n    baseline\n    variation\n    target\n    variationLevel\n  }\n}\n    "], ["\n    query getLastAssayResults {\n  lastAssayResults {\n    id\n    indicatorId\n    name\n    value\n    eventDate\n    baseline\n    variation\n    target\n    variationLevel\n  }\n}\n    "])));
/**
 * __useGetLastAssayResultsQuery__
 *
 * To run a query within a React component, call `useGetLastAssayResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAssayResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAssayResultsQuery({
 *   variables: {
 *   },
 * });
 */
function useGetLastAssayResultsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetLastAssayResultsDocument, options);
}
function useGetLastAssayResultsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetLastAssayResultsDocument, options);
}
exports.ListAminoAcidsAssaysResultsDocument = (0, client_1.gql)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n    query listAminoAcidsAssaysResults($indicatorId: ID!, $first: Int = 200, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  getAssays(\n    indicatorId: $indicatorId\n    indicatorType: Aminoacids\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        eventDate\n        value\n        variationLevel\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query listAminoAcidsAssaysResults($indicatorId: ID!, $first: Int = 200, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  getAssays(\n    indicatorId: $indicatorId\n    indicatorType: Aminoacids\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        eventDate\n        value\n        variationLevel\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useListAminoAcidsAssaysResultsQuery__
 *
 * To run a query within a React component, call `useListAminoAcidsAssaysResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAminoAcidsAssaysResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAminoAcidsAssaysResultsQuery({
 *   variables: {
 *      indicatorId: // value for 'indicatorId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useListAminoAcidsAssaysResultsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListAminoAcidsAssaysResultsDocument, options);
}
function useListAminoAcidsAssaysResultsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListAminoAcidsAssaysResultsDocument, options);
}
exports.ListBhbAssaysResultsDocument = (0, client_1.gql)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n    query listBhbAssaysResults($first: Int = 200, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  getAssays(\n    indicatorId: 4\n    indicatorType: Bhb\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        eventDate\n        value\n        bottomLimit\n        upperLimit\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query listBhbAssaysResults($first: Int = 200, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  getAssays(\n    indicatorId: 4\n    indicatorType: Bhb\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        eventDate\n        value\n        bottomLimit\n        upperLimit\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useListBhbAssaysResultsQuery__
 *
 * To run a query within a React component, call `useListBhbAssaysResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBhbAssaysResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBhbAssaysResultsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useListBhbAssaysResultsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListBhbAssaysResultsDocument, options);
}
function useListBhbAssaysResultsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListBhbAssaysResultsDocument, options);
}
exports.GetRecipesDocument = (0, client_1.gql)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n    query getRecipes($offset: Int = 0, $limit: Int = 10) {\n  recipes(offset: $offset, limit: $limit) {\n    id\n    video\n    recipeTitle\n    video\n    coverImage\n    recipeType\n    publishedAt\n  }\n}\n    "], ["\n    query getRecipes($offset: Int = 0, $limit: Int = 10) {\n  recipes(offset: $offset, limit: $limit) {\n    id\n    video\n    recipeTitle\n    video\n    coverImage\n    recipeType\n    publishedAt\n  }\n}\n    "])));
/**
 * __useGetRecipesQuery__
 *
 * To run a query within a React component, call `useGetRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
function useGetRecipesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRecipesDocument, options);
}
function useGetRecipesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRecipesDocument, options);
}
exports.GetRecipesV2Document = (0, client_1.gql)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n    query getRecipesV2($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  recipesV2(first: $first, after: $after, filterBy: $filterBy, sortBy: $sortBy) {\n    edges {\n      cursor\n      node {\n        id\n        name\n        coverImage\n        recipeType\n        video\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query getRecipesV2($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  recipesV2(first: $first, after: $after, filterBy: $filterBy, sortBy: $sortBy) {\n    edges {\n      cursor\n      node {\n        id\n        name\n        coverImage\n        recipeType\n        video\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useGetRecipesV2Query__
 *
 * To run a query within a React component, call `useGetRecipesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipesV2Query({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useGetRecipesV2Query(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRecipesV2Document, options);
}
function useGetRecipesV2LazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRecipesV2Document, options);
}
exports.GetRecipeDocument = (0, client_1.gql)(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    query getRecipe($recipeId: ID!) {\n  recipe(recipeId: $recipeId) {\n    id\n    recipeTitle\n    coverImage\n    video\n    recipeDescription\n    recipeType\n    servings\n    ingredients\n    instructions\n    publishedAt\n  }\n}\n    "], ["\n    query getRecipe($recipeId: ID!) {\n  recipe(recipeId: $recipeId) {\n    id\n    recipeTitle\n    coverImage\n    video\n    recipeDescription\n    recipeType\n    servings\n    ingredients\n    instructions\n    publishedAt\n  }\n}\n    "])));
/**
 * __useGetRecipeQuery__
 *
 * To run a query within a React component, call `useGetRecipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipeQuery({
 *   variables: {
 *      recipeId: // value for 'recipeId'
 *   },
 * });
 */
function useGetRecipeQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRecipeDocument, options);
}
function useGetRecipeLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRecipeDocument, options);
}
exports.GetUserIntercomHashKeyDocument = (0, client_1.gql)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    query getUserIntercomHashKey($platform: PlatformType!) {\n  userIntercomHashKey(platform: $platform)\n}\n    "], ["\n    query getUserIntercomHashKey($platform: PlatformType!) {\n  userIntercomHashKey(platform: $platform)\n}\n    "])));
/**
 * __useGetUserIntercomHashKeyQuery__
 *
 * To run a query within a React component, call `useGetUserIntercomHashKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIntercomHashKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIntercomHashKeyQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
function useGetUserIntercomHashKeyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetUserIntercomHashKeyDocument, options);
}
function useGetUserIntercomHashKeyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetUserIntercomHashKeyDocument, options);
}
exports.ListAnytimeSurveyAssignmentsDocument = (0, client_1.gql)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n    query listAnytimeSurveyAssignments($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  anytimeSurveyAssignments(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        patientId\n        surveyId\n        name\n        label\n        assignmentType\n        createdAt\n        updatedAt\n        createdBy\n        updatedBy\n        lastRespondedAt\n        questions {\n          id\n          type\n          title\n          helpText\n          placeholderText\n          maxLength\n          required\n          possibleAnswers\n          possibleAnswersIcons\n          possibleAnswersDescriptions\n          footnote\n          answer\n          logic {\n            conditionQuestion {\n              value\n              index\n              type\n            }\n            condition\n            conditionAnswer\n            action\n          }\n          customPropsOfType {\n            ... on ExplanationProps {\n              headerAsset\n              content {\n                type\n                data\n              }\n            }\n            ... on DecimalProps {\n              min\n              max\n              unit\n              numberOfDecimals\n            }\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "], ["\n    query listAnytimeSurveyAssignments($first: Int = 10, $after: String, $filterBy: FilterBy, $sortBy: SortBy) {\n  anytimeSurveyAssignments(\n    first: $first\n    after: $after\n    filterBy: $filterBy\n    sortBy: $sortBy\n  ) {\n    edges {\n      node {\n        id\n        patientId\n        surveyId\n        name\n        label\n        assignmentType\n        createdAt\n        updatedAt\n        createdBy\n        updatedBy\n        lastRespondedAt\n        questions {\n          id\n          type\n          title\n          helpText\n          placeholderText\n          maxLength\n          required\n          possibleAnswers\n          possibleAnswersIcons\n          possibleAnswersDescriptions\n          footnote\n          answer\n          logic {\n            conditionQuestion {\n              value\n              index\n              type\n            }\n            condition\n            conditionAnswer\n            action\n          }\n          customPropsOfType {\n            ... on ExplanationProps {\n              headerAsset\n              content {\n                type\n                data\n              }\n            }\n            ... on DecimalProps {\n              min\n              max\n              unit\n              numberOfDecimals\n            }\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalNumberFound\n  }\n}\n    "])));
/**
 * __useListAnytimeSurveyAssignmentsQuery__
 *
 * To run a query within a React component, call `useListAnytimeSurveyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAnytimeSurveyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAnytimeSurveyAssignmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
function useListAnytimeSurveyAssignmentsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ListAnytimeSurveyAssignmentsDocument, options);
}
function useListAnytimeSurveyAssignmentsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ListAnytimeSurveyAssignmentsDocument, options);
}
exports.GetMealKitDocument = (0, client_1.gql)(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n    query getMealKit($id: ID!) {\n  mealKit(id: $id) {\n    id\n    name\n    photoUrl\n    description\n    ingredients {\n      id\n      name\n      type\n      isSelectable\n      quantity\n      unit\n      isIncluded\n      photoUrl\n    }\n    variants {\n      id\n      name\n      type\n      photoUrl\n      variantId\n      quantity\n      unit\n    }\n    nutritionalValues {\n      url\n      ingredientName\n    }\n    tags {\n      id\n      name\n      icon\n      color\n      borderColor\n      isPinned\n    }\n    instructions\n    equipment\n  }\n}\n    "], ["\n    query getMealKit($id: ID!) {\n  mealKit(id: $id) {\n    id\n    name\n    photoUrl\n    description\n    ingredients {\n      id\n      name\n      type\n      isSelectable\n      quantity\n      unit\n      isIncluded\n      photoUrl\n    }\n    variants {\n      id\n      name\n      type\n      photoUrl\n      variantId\n      quantity\n      unit\n    }\n    nutritionalValues {\n      url\n      ingredientName\n    }\n    tags {\n      id\n      name\n      icon\n      color\n      borderColor\n      isPinned\n    }\n    instructions\n    equipment\n  }\n}\n    "])));
/**
 * __useGetMealKitQuery__
 *
 * To run a query within a React component, call `useGetMealKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealKitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetMealKitQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetMealKitDocument, options);
}
function useGetMealKitLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetMealKitDocument, options);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58;
